<template>
	<div class="main-page" :style="{ height: iframeHeight }">
		
		<iframe
		      :src="mainUrl"
			  class="iframe-box"
		      frameborder="0"
			  :style="{ height: iframeHeight }"
		      allowfullscreen
		    ></iframe>
			<div ref="bottomHeight" class="bottom-height"></div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				mainUrl: '', //https://www.cogfslabc.com/
				iframeHeight: '100vh'
			}
		},
		created() {
			this.$nextTick(()=>{
				this.changeFrameHeight()
				let timestamp = '?timestamp=' + new Date().getTime()
				if(process.env.NODE_ENV === 'development') {
				   this.mainUrl = 'http://172.20.10.2:8083/' + timestamp
				} else {
				 let host = window.location.hostname.split('.').slice(-2).join('.')
				   this.mainUrl = 'https://www.' + host + timestamp　　　　　　　　　
				} 
			})
		},
		methods:{
			changeFrameHeight(){
				let height = document.documentElement.clientHeight;
				let bottomHeight = this.$refs.bottomHeight.offsetHeight;
				if(bottomHeight > 0) bottomHeight = bottomHeight / 2 - 4;
				
				this.iframeHeight = (height + bottomHeight) + 'px';
				
			},
			
		}
	}
</script>

<style lang="less">
	.main-page {
		position: relative;
		overflow: hidden;
		background-color: #111621;
	}
	.iframe-box {
		width: 100%;
		height: 100vh;
	}
	.bottom-height{
		height: constant(safe-area-inset-bottom);
		height: env(safe-area-inset-bottom);
		width: 100%;
	}
	
</style>